/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Agent from './Agent';
import ContractApplication from './ContractApplication';
import ContractApplicationAttachmentFile from './ContractApplicationAttachmentFile';
import User from './User';

/**
 * The ContractApplicationPostRequest model module.
 * @module model/ContractApplicationPostRequest
 * @version 1.0.0
 */
class ContractApplicationPostRequest {
    /**
     * Constructs a new <code>ContractApplicationPostRequest</code>.
     * @alias module:model/ContractApplicationPostRequest
     * @implements module:model/ContractApplication
     * @param proposalMatchingId {Number} 
     */
    constructor(proposalMatchingId) { 
        ContractApplication.initialize(this);
        ContractApplicationPostRequest.initialize(this, proposalMatchingId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, proposalMatchingId) { 
        obj['proposal_matching_id'] = proposalMatchingId;
    }

    /**
     * Constructs a <code>ContractApplicationPostRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ContractApplicationPostRequest} obj Optional instance to populate.
     * @return {module:model/ContractApplicationPostRequest} The populated <code>ContractApplicationPostRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ContractApplicationPostRequest();
            ContractApplication.constructFromObject(data, obj);

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('proposal_matching_id')) {
                obj['proposal_matching_id'] = ApiClient.convertToType(data['proposal_matching_id'], 'Number');
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('application_date')) {
                obj['application_date'] = ApiClient.convertToType(data['application_date'], 'Date');
            }
            if (data.hasOwnProperty('contract_price')) {
                obj['contract_price'] = ApiClient.convertToType(data['contract_price'], 'Number');
            }
            if (data.hasOwnProperty('contract_property_name')) {
                obj['contract_property_name'] = ApiClient.convertToType(data['contract_property_name'], 'String');
            }
            if (data.hasOwnProperty('contract_date')) {
                obj['contract_date'] = ApiClient.convertToType(data['contract_date'], 'Date');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('user_registered_at')) {
                obj['user_registered_at'] = ApiClient.convertToType(data['user_registered_at'], 'Date');
            }
            if (data.hasOwnProperty('agent')) {
                obj['agent'] = Agent.constructFromObject(data['agent']);
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = User.constructFromObject(data['user']);
            }
            if (data.hasOwnProperty('contract_application_attachment_files')) {
                obj['contract_application_attachment_files'] = ApiClient.convertToType(data['contract_application_attachment_files'], [ContractApplicationAttachmentFile]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ContractApplicationPostRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ContractApplicationPostRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ContractApplicationPostRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['contract_property_name'] && !(typeof data['contract_property_name'] === 'string' || data['contract_property_name'] instanceof String)) {
            throw new Error("Expected the field `contract_property_name` to be a primitive type in the JSON string but got " + data['contract_property_name']);
        }
        // validate the optional field `agent`
        if (data['agent']) { // data not null
          Agent.validateJSON(data['agent']);
        }
        // validate the optional field `user`
        if (data['user']) { // data not null
          User.validateJSON(data['user']);
        }
        if (data['contract_application_attachment_files']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contract_application_attachment_files'])) {
                throw new Error("Expected the field `contract_application_attachment_files` to be an array in the JSON data but got " + data['contract_application_attachment_files']);
            }
            // validate the optional field `contract_application_attachment_files` (array)
            for (const item of data['contract_application_attachment_files']) {
                ContractApplicationAttachmentFile.validateJSON(item);
            };
        }

        return true;
    }


}

ContractApplicationPostRequest.RequiredProperties = ["proposal_matching_id"];

/**
 * @member {Number} id
 */
ContractApplicationPostRequest.prototype['id'] = undefined;

/**
 * @member {Number} proposal_matching_id
 */
ContractApplicationPostRequest.prototype['proposal_matching_id'] = undefined;

/**
 * @member {Number} agent_id
 */
ContractApplicationPostRequest.prototype['agent_id'] = undefined;

/**
 * @member {Number} user_id
 */
ContractApplicationPostRequest.prototype['user_id'] = undefined;

/**
 * @member {Date} application_date
 */
ContractApplicationPostRequest.prototype['application_date'] = undefined;

/**
 * @member {Number} contract_price
 */
ContractApplicationPostRequest.prototype['contract_price'] = undefined;

/**
 * @member {String} contract_property_name
 */
ContractApplicationPostRequest.prototype['contract_property_name'] = undefined;

/**
 * @member {Date} contract_date
 */
ContractApplicationPostRequest.prototype['contract_date'] = undefined;

/**
 * @member {Date} created_at
 */
ContractApplicationPostRequest.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
ContractApplicationPostRequest.prototype['updated_at'] = undefined;

/**
 * @member {Date} user_registered_at
 */
ContractApplicationPostRequest.prototype['user_registered_at'] = undefined;

/**
 * @member {module:model/Agent} agent
 */
ContractApplicationPostRequest.prototype['agent'] = undefined;

/**
 * @member {module:model/User} user
 */
ContractApplicationPostRequest.prototype['user'] = undefined;

/**
 * @member {Array.<module:model/ContractApplicationAttachmentFile>} contract_application_attachment_files
 */
ContractApplicationPostRequest.prototype['contract_application_attachment_files'] = undefined;


// Implement ContractApplication interface:
/**
 * @member {Number} id
 */
ContractApplication.prototype['id'] = undefined;
/**
 * @member {Number} proposal_matching_id
 */
ContractApplication.prototype['proposal_matching_id'] = undefined;
/**
 * @member {Number} agent_id
 */
ContractApplication.prototype['agent_id'] = undefined;
/**
 * @member {Number} user_id
 */
ContractApplication.prototype['user_id'] = undefined;
/**
 * @member {Date} application_date
 */
ContractApplication.prototype['application_date'] = undefined;
/**
 * @member {Number} contract_price
 */
ContractApplication.prototype['contract_price'] = undefined;
/**
 * @member {String} contract_property_name
 */
ContractApplication.prototype['contract_property_name'] = undefined;
/**
 * @member {Date} contract_date
 */
ContractApplication.prototype['contract_date'] = undefined;
/**
 * @member {Date} created_at
 */
ContractApplication.prototype['created_at'] = undefined;
/**
 * @member {Date} updated_at
 */
ContractApplication.prototype['updated_at'] = undefined;
/**
 * @member {Date} user_registered_at
 */
ContractApplication.prototype['user_registered_at'] = undefined;
/**
 * @member {module:model/Agent} agent
 */
ContractApplication.prototype['agent'] = undefined;
/**
 * @member {module:model/User} user
 */
ContractApplication.prototype['user'] = undefined;
/**
 * @member {Array.<module:model/ContractApplicationAttachmentFile>} contract_application_attachment_files
 */
ContractApplication.prototype['contract_application_attachment_files'] = undefined;




export default ContractApplicationPostRequest;

